import { getActivityType } from 'configuration/activityTypeTopicContentTypeMappings';
import { TopicBadge } from 'models/topicBadge';

interface TopicData {
    topicType?: number;
    topicContentType?: number;
    videoPresentationType?: number;
}

export class TopicBadgesFactory {
    buildBadge(topic: TopicData) {
        const isGroup = topic.topicType === enums.TopicType.TopicGroup.value;

        if (isGroup)
            return new TopicBadge(enums.ActivityTypes.ActivityGroup);

        if (topic.topicContentType) {
            const activityTypeValue = getActivityType(topic.topicContentType)

            if (activityTypeValue) {
                const activityType = _(enums.ActivityTypes).find(type => type.value === activityTypeValue);

                if (activityType)
                    return new TopicBadge(activityType);
            }                
        }

        return new TopicBadge(enums.ActivityTypes.SocialPost);
    }
}

const instance = new TopicBadgesFactory();

export default instance;